import { delay, generateUID } from "@/lib/utils";
import { Teacher, CreateTeacherInput } from "./teacher.interfaces";
import { mockIds } from "../mockIds";

const mockTeachers: Teacher[] = [
  {
    id: mockIds.user1,
    name: "John Doe",
    email: "john@example.com",
    status: "Active",
    lastLogin: "2023-10-01",
    linkedStudents: 10,
    enrollmentDate: "2023-09-01",
    subjects: ["Math", "Science"],
    avatar: {
      url: "https://randomuser.me/api/portraits/men/21.jpg",
      alt: "John Doe",
    },
  },
  {
    id: mockIds.user2,
    name: "Jane Smith",
    email: "jane@example.com",
    status: "Inactive",
    lastLogin: "2023-09-25",
    enrollmentDate: "2023-08-15",
    linkedStudents: 5,
    subjects: ["History"],
    avatar: {
      url: "https://randomuser.me/api/portraits/women/22.jpg",
      alt: "Jane Smith",
    },
  },
  {
    id: generateUID(),
    name: "Alice Johnson",
    email: "alice@example.com",
    status: "Active",
    lastLogin: "2023-11-01",
    enrollmentDate: "2023-10-15",
    linkedStudents: 8,
    subjects: ["English"],
    avatar: {
      url: "https://randomuser.me/api/portraits/women/23.jpg",
      alt: "Alice Johnson",
    },
  },
  {
    id: generateUID(),
    name: "Bob Williams",
    email: "bob@example.com",
    status: "Active",
    lastLogin: "2023-11-10",
    enrollmentDate: "2023-11-01",
    linkedStudents: 12,
    subjects: ["Physics"],
    avatar: {
      url: "https://randomuser.me/api/portraits/men/24.jpg",
      alt: "Bob Williams",
    },
  },
  {
    id: generateUID(),
    name: "Charlie Brown",
    email: "charlie@example.com",
    status: "Inactive",
    lastLogin: "2023-11-15",
    enrollmentDate: "2023-11-05",
    linkedStudents: 3,
    subjects: ["Chemistry"],
    avatar: {
      url: "https://randomuser.me/api/portraits/men/25.jpg",
      alt: "Charlie Brown",
    },
  },
];

const getRandomAvatar = (name: string, gender?: 'men' | 'women') => {
  const randomNumber = Math.floor(Math.random() * 99);
  const randomGender = gender || (Math.random() > 0.5 ? 'men' : 'women');
  return {
    url: `https://randomuser.me/api/portraits/${randomGender}/${randomNumber}.jpg`,
    alt: name,
  };
};

export const getTeachers = async (page: number = 1): Promise<Teacher[]> => {
  await delay(100);
  // Retorna array vazio para qualquer página além da primeira
  if (page > 1) {
    return [];
  }
  // Na primeira página, retorna todos os professores mockados
  return mockTeachers;
};

export const getTeacherById = async (id: string): Promise<Teacher> => {
  await delay(100);
  const teacher = mockTeachers.find((t) => t.id === id);
  if (!teacher) throw new Error("Teacher not found");
  return teacher;
};

export const createTeacher = async (
  teacher: CreateTeacherInput
): Promise<Teacher> => {
  await delay(100);
  const newTeacher: Teacher = {
    ...teacher,
    id: generateUID(),
    avatar: getRandomAvatar(teacher.name),
    lastLogin: new Date().toISOString(),
    linkedStudents: 0,
    subjects: []
  };
  mockTeachers.push(newTeacher);
  return newTeacher;
};

export const updateTeacher = async (
  id: string,
  teacher: Partial<Teacher>
): Promise<Teacher> => {
  await delay(100);
  const index = mockTeachers.findIndex((t) => t.id === id);
  if (index === -1) throw new Error("Teacher not found");
  mockTeachers[index] = { ...mockTeachers[index], ...teacher };
  return mockTeachers[index];
};

export const deleteTeacher = async (id: string): Promise<void> => {
  await delay(100);
  const index = mockTeachers.findIndex((t) => t.id === id);
  if (index === -1) throw new Error("Teacher not found");
  mockTeachers.splice(index, 1);
};
